import script from "./TyreBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TyreBox.vue?vue&type=script&setup=true&lang=js"

import "./TyreBox.vue?vue&type=style&index=0&id=394548d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394548d0"]])

export default __exports__